import { WMSTileLayer } from "react-leaflet";
import { useSelectedPersonalLayers } from "hooks/layerHooks";

export function RenderPersonalLayers() {
  const selectedPersonalLayers = useSelectedPersonalLayers();

  return (
    <>
      {selectedPersonalLayers.map((personalLayer) => (
        <WMSTileLayer key={personalLayer.id} {...personalLayer.wms} />
      ))}
    </>
  );
}
